var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-card"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.data.prompt)+" ")]),_c('div',{staticClass:"btn",on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.data.card_name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }